import { Star } from "lucide-react";
import { useActiveAds, featuredAds } from "@/lib/ads";

export const FeaturedPartners = () => {
  const ads = featuredAds(useActiveAds());
  if (!ads.length) return null;
  return (
    <section data-testid="featured-partners" className="bg-[#13141A] text-white">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-12 md:py-24">
        <div className="flex items-center gap-2 mb-3">
          <p className="font-body font-800 text-xs tracking-[0.3em] eyebrow text-[#DF3226]">FEATURED PARTNERS</p>
        </div>
        <h2 className="font-display font-900 tracking-tighter leading-[0.9] text-4xl sm:text-5xl">
          Loved by locals,<br />
          <span className="font-editorial italic font-600">worth your time</span>
        </h2>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ads.map((ad) => (
            <div
              key={ad.id}
              data-testid={`featured-partner-${ad.id}`}
              className="bg-white/[0.04] border border-white/10 p-6 hover:bg-white/[0.07] transition-colors flex flex-col"
            >
              <span className="font-body font-800 text-[10px] tracking-widest text-white/40">
                SPONSORED · {ad.category}
              </span>
              {ad.website ? (
                <a
                  href={ad.website}
                  target="_blank"
                  rel="noopener noreferrer nofollow sponsored"
                  data-testid={`featured-partner-link-${ad.id}`}
                  className="font-display font-900 tracking-tight text-2xl mt-2 inline-block text-white underline decoration-1 underline-offset-2 decoration-white/30 hover:decoration-[#DF3226] hover:text-[#DF3226] transition-colors"
                >
                  {ad.business_name}
                </a>
              ) : (
                <h3 className="font-display font-900 tracking-tight text-2xl mt-2">{ad.business_name}</h3>
              )}
              <p className="font-body text-sm text-white/70 mt-2 leading-relaxed flex-1">{ad.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
